import {
    fetchLabels as _fetchLabels,
    createLabel as _createLabel,
    updateLabel as _updateLabel,
    deleteLabel as _deleteLabel
} from "../../../utils/api.js";

export const fetchLabels = (projectId, params) =>
    _fetchLabels(projectId, params);

export const createLabel = (projectId, payload) =>
    _createLabel(projectId, payload);

export const updateLabel = (projectId, id, payload) =>
    _updateLabel(projectId, id, payload);

export const deleteLabel = (projectId, id) =>
    _deleteLabel(projectId, id);